import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfMeasurementObjectCtrl is a controller class that extends BaseObjectDirective.
 * It handles the measurement object functionality within the application.
 */
export class AsfMeasurementObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfMeasurementObjectCtrl.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $injector - Angular injector service.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $rootScope - Angular root scope object.
     * @param {Object} $routeParams - Angular route parameters.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $timeout - Angular timeout service.
     * @param {Object} $q - Angular promise service.
     * @param {Object} ObjectInstanceRegistrationService - Service for object instance registration.
     * @param {Object} APIService - API service for backend communication.
     * @param {Object} $interval - Angular interval service.
     * @param {Object} SheetLoadedService - Service for sheet loading events.
     */
    constructor($scope, $injector, $uibModal, $rootScope, $routeParams, TaskDataService, $signals, $timeout, $q, ObjectInstanceRegistrationService, APIService, $interval, SheetLoadedService) {
        super($injector, $scope);
        this.$scope = $scope;
        this.$injector = $injector;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.TaskDataService = TaskDataService;
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.$q = $q;
        this.ObjectInstanceRegistrationService = ObjectInstanceRegistrationService;
        this.APIService = APIService;
        this.$interval = $interval;
        this.SheetLoadedService = SheetLoadedService;

        $injector.invoke(this.init, this, {$scope: $scope});

        this.taskContext = TaskDataService.fetchContext();

        $scope.isCMS = $rootScope.isCMS;
        $scope.isPreview = $rootScope.isPreview;
        $scope.prefsMode = false;
        $scope.hasBrowseImage = true; //show media manager button
        $scope.taskuuid = $routeParams.taskUUID;
        $scope.objectUUID = $scope.contentObject.getUUID();
        $scope.measurementObjectURL = '';
        $scope.measurementObjectValue = '';
        $scope.measurementObjectTextValue = '';

        if (typeof($scope.containerObject) === 'object') {
            $scope.inTabOrCarousel = $scope.containerObject.isShowTabs() || $scope.containerObject.isShowCarousels() ? true : false;
        }

        if (typeof $scope.subContainerKey !== 'undefined' && $scope.inTabOrCarousel) {
            if ($scope.containerObject.isShowTabs()) {
                let contentUUID = ($scope.containerObject.getTabs()[$scope.subContainerKey]).content;
                let content = taskContext.read(contentUUID);
                $scope.objectsInSubContainer = content.getObjects();
            } else if ($scope.containerObject.isShowCarousels()) {
                let contentUUID = ($scope.containerObject.getCarousels()[$scope.subContainerKey]).content;
                let content = taskContext.read(contentUUID);
                $scope.objectsInSubContainer = content.getObjects();
            }
        }

        this.baseUnitUpdated = false;
        this.initPreferences();
    }

    /**
     * Updates the measurement object with the given preferences.
     * @param {Object} preferences - The preferences to apply to the measurement object.
     */
    updateObjectWithPreferences(preferences) {
        angular.forEach(preferences, (value, key) => {
            if (key == "mediaContent") {
                var mo = this.getMediaObject();

                if (Object.keys(mo).length) {
                    var applyUrl = (secureUrl) => {
                        this.$scope.measurementObject['loadImage'](secureUrl, {'width': mo.getWidth(),'height': mo.getHeight()});
                    };
                    if (angular.isDefined(mo) && angular.isFunction(mo.getSecureURL)) {
                        mo.getSecureURL(this.$routeParams.taskUUID).then(applyUrl);
                    }
                }
            } else if (key == "setBaseUnitFromLine") {
                // ignore
            } else if (key == "targetTextBoxObject") {
                // ignore
            } else if (key == "setBaseUnit") {
                if (this.baseUnitUpdated) {
                    this.$timeout.cancel(this.baseUnitUpdated);
                }
                this.baseUnitUpdated = this.$timeout(() => {
                    value = value.toString().replace(",", ".");
                    this.$scope.measurementObject[key](value);
                    this.$scope.preferencesValues['setBaseUnit'] = value;
                }, 100);
            } else if (this.$scope.measurementObject.hasOwnProperty(key)) {
                this.$scope.measurementObject[key](value);
            }
        });
    }

    /**
     * Updates the preferences based on the current scope values.
     * @returns {Object} The updated preferences.
     */
    updatePreferences() {
        var preferences = this.$scope.contentObject.getPreferences();
        angular.forEach(this.$scope.preferencesValues, (value, key) => {
            preferences[key] = value;
        });
        this.$scope.contentObject.setPreferences(preferences);
        return preferences;
    }

    /**
     * Handles the new measurement event.
     * @param {Object} x - The new measurement data.
     */
    newMeasurementHandler(x) {
        var doOutput = this.$rootScope.viewMode === 'preview' || !this.$scope.isCMS;
        console.log('New measurement: ', x);
        var textToAppend = x.value + ' ' + x.unit + "\n";

        this.$scope.$apply(() => {
            this.$scope.measurementObjectValue = JSON.stringify(x);
            this.$scope.preferences['02-setBaseUnitFromLine'][0].disabled = false;
        });

        if (!doOutput) {
            console.log('Not transferring new measurement to output box, not in frontend/preview mode: ', x);
            return;
        }

        var targetTextBoxObjectUUID = this.$scope.contentObject.getPreferences().targetTextBoxObject;
        if (!angular.isDefined(targetTextBoxObjectUUID) || targetTextBoxObjectUUID === '') {
            return;
        }

        var targetTextBoxObject = this.ObjectInstanceRegistrationService.getObjectByUUID(targetTextBoxObjectUUID);
        if (angular.isDefined(targetTextBoxObject)) {
            targetTextBoxObject.appendText(textToAppend);
        } else {
            console.error("Measurement Target Textbox with UUID " + targetTextBoxObjectUUID + " not found!");
        }
    }

    /**
     * Handles the beginning of a measurement event.
     */
    beginMeasurementHandler() {
        this.$scope.$apply(() => {
            this.$scope.preferences['02-setBaseUnitFromLine'][0].disabled = true;
            this.$scope.preferencesValues['setBaseUnitFromLine'] = '';
        });
    }

    /**
     * Handles the image loaded event.
     * @param {Object} dimensions - The dimensions of the loaded image.
     */
    imageLoadedHandler(dimensions) {
        this.$scope.$apply(() => {
            this.$scope.iFrameStyle.height = dimensions.height + 'px';
            this.$timeout(() => {
                this._d.resolve('measurementObject');
            }, 1000);
        });
    }

    /**
     * Handles the iframe ready event.
     * @param {string} objectUUID - The UUID of the object.
     */
    onIframeReady(objectUUID) {
        if (typeof objectUUID != 'undefined' && objectUUID == this.$scope.objectUUID) {
            this.$scope.measurementObject = this.ObjectInstanceRegistrationService.getObjectByUUID(this.$scope.objectUUID);
            this.$scope.measurementObject.onImageLoaded(this.imageLoadedHandler);
            this.$scope.measurementObject.onMeasurement(this.newMeasurementHandler);
            this.$scope.measurementObject.onBeginMeasurement(this.beginMeasurementHandler);

            this.updateObjectWithPreferences(this.$scope.contentObject.getPreferences());
        }
    }

    /**
     * Extracts the content UUID from the given URL.
     * @param {string} url - The URL to extract the UUID from.
     * @returns {string} The extracted UUID.
     */
    getContentUUIDFromPath(url) {
        var _file = url.substring(url.lastIndexOf("/") + 1),
            _uuid;

        if (angular.isUUID(_file, true)) {
            _uuid = _file;
        } else if (_file.lastIndexOf(".") != -1) {
            _uuid = _file.substring(0, _file.lastIndexOf("."));
        } else {
            console.error('could get UUID from content Object');
        }
        return _uuid;
    }

    /**
     * Retrieves the media object based on the content object's media content preference.
     * @returns {Object} The media object.
     */
    getMediaObject() {
        var _mediaContent = this.$scope.contentObject.getPreference('mediaContent'),
            _mediaUUID,
            _mediaObject = {};

        if (typeof _mediaContent != 'undefined' || _mediaContent) {
            _mediaUUID = this.getContentUUIDFromPath(_mediaContent);
            _mediaObject = this.taskContext.read(_mediaUUID);
        }
        return _mediaObject;
    }

    /**
     * Initializes the preferences for the measurement object.
     */
    initPreferences() {
        var setUnit = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setUnit : undefined),
            setViewScale = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setViewScale : undefined),
            setLineColor = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setLineColor : undefined),
            setLineShadowColor = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setLineShadowColor : undefined),
            setTextColor = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setTextColor : undefined),
            setTextShadowColor = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setTextShadowColor : undefined),
            setBaseUnitFromLine = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setBaseUnitFromLine : undefined),
            setBaseUnit = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setBaseUnit : undefined),
            setScaleLineUnits = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().setScaleLineUnits : undefined),
            targetTextBoxObject = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().targetTextBoxObject : undefined),
            includedInPDF = (typeof this.$scope.contentObject.getPreferences() !== "undefined" ? this.$scope.contentObject.getPreferences().includedInPDF : false);

        this.$scope.$watch('preferencesValues', (val1, val2) => {
            (val1 != val2) && this.updateObjectWithPreferences(this.updatePreferences());
        }, true);

        this.$scope.preferencesValues = {};
        this.$scope.preferencesValues['setUnit'] = setUnit;
        this.$scope.preferencesValues['setViewScale'] = setViewScale;
        this.$scope.preferencesValues['setLineColor'] = setLineColor;
        this.$scope.preferencesValues['setLineShadowColor'] = setLineShadowColor;
        this.$scope.preferencesValues['setTextColor'] = setTextColor;
        this.$scope.preferencesValues['setTextShadowColor'] = setTextShadowColor;
        this.$scope.preferencesValues['setBaseUnitFromLine'] = ''; //setBaseUnitFromLine;
        this.$scope.preferencesValues['setBaseUnit'] = setBaseUnit;
        this.$scope.preferencesValues['setScaleLineUnits'] = setScaleLineUnits;
        this.$scope.preferencesValues['targetTextBoxObject'] = targetTextBoxObject;
        this.$scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : false;

        this.$scope.preferences = [
            {
                '01-setLineColor': [
                    {'type': 'colorpicker', 'name': 'Line colour:', 'valueKey': 'setLineColor'}
                ],
                '03-setLineShadowColor': [
                    {'type': 'colorpicker', 'name': 'Line shadow colour:', 'valueKey': 'setLineShadowColor'}
                ],
                '05-setTextColor': [
                    {'type': 'colorpicker', 'name': 'Text colour:', 'valueKey': 'setTextColor'}
                ],
                '07-setTextShadowColor': [
                    {'type': 'colorpicker', 'name': 'Text shadow colour:', 'valueKey': 'setTextShadowColor'}
                ],
                '02-setBaseUnitFromLine': [
                    {
                        'type': 'input', 'name': 'Convert base unit from measurement', 'valueKey': 'setBaseUnitFromLine', 'disabled': true,
                        'placeholder': 'Measurement in units',
                        'actionText': 'Convert',
                        'action': () => {
                            this.$scope.measurementObject.setBaseUnitFromLine(
                                this.$scope.preferencesValues['setBaseUnitFromLine']
                            );
                            this.$scope.preferencesValues['setBaseUnit'] = this.$scope.measurementObject.getBaseUnit();
                        }
                    },
                ],
                '02b-setBaseUnit': [
                    {'type': 'input', 'name': 'Unit to Pixel ratio', 'valueKey': 'setBaseUnit'}
                ],
                '04-setScaleLineUnits': [
                    {'type': 'input', 'name': 'Scale size (units)', 'valueKey': 'setScaleLineUnits'}
                ],
                '06-setUnit': [
                    {'type': 'input', 'name': 'Unit Text:', 'valueKey': 'setUnit'}
                ],
                '08-setViewScale': [
                    {'type': 'checkbox', 'name': 'Scale visible?', 'valueKey': 'setViewScale'}
                ],
                '10-targetTextBoxObject': [
                    {'type': 'select-other-content-object', 'name': 'Target Textbox for Measurements', 'valueKey': 'targetTextBoxObject', 'objectType': 'text'}
                ],
                '11-includedInPDF': [
                    {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                ]
            },
        ];
    }

    /**
     * Handles the media browse button click event.
     */
    onMediaBrowseButtonClick() {
        this.modalInstance = this.$uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediabrowserModal.html',
            scope: this.$scope,
            controller: function ($scope, $uibModalInstance, contentObjectUUID) {
                $scope.showonly = 'measurementobject';
                $scope.contentobjectuuid = contentObjectUUID;

                $scope.onModalCloseButtonClick = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            },
            resolve: {
                'contentObjectUUID': () => {
                    return this.$scope.contentObject.getUUID();
                }
            }
        });
    }

    /**
     * Handles the selection of media.
     * @param {Object} selectedMedia - The selected media object.
     */
    onSelectMedia(selectedMedia) {
        console.log("%cImageObjectDirective", 'color:teal', selectedMedia);

        if (selectedMedia.contentobjectuuid == this.$scope.contentObject.getUUID()) {
            this.$scope.contentObject.setPreference('mediaContent', selectedMedia.uuid);
            this.$scope.preferencesValues['mediaContent'] = selectedMedia.uuid; /*CONTINUED*/

            if (this.modalInstance !== null) {
                this.modalInstance.close();
            }
        }
    }
}

export default function registerAsfMeasurementObjectDirective(module) {
    module.directive('asfMeasurementObject', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "=",
                "containerObject": "=",
                "subContainerKey": "="
            },
            templateUrl: "/views/ib/contentobjects/measurementobject.html",
            controller: AsfMeasurementObjectCtrl
        };
    });

    // Register Object at ContentObjectRegistryService so it is available in palette
    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        var obj = [{
            "uuid": "",
            "content": "",
            "objectType": "measurement",
            "type": "contentObject",
            "contentReference": false,
            "preferences": {
                "setBaseUnitFromLine": "1",
                "setBaseUnit": "1",
                "setLineColor": "#00FF00",
                "setLineShadowColor": "#000000",
                "setScaleLineUnits": "1",
                "setTextColor": "#FFFFFF",
                "setTextShadowColor": "#000000",
                "mediaContent" : undefined,
                "setViewScale": false,
                "setUnit": "Nanometers",
                "includedInPDF" : false,
                "data": {
                    "measurement": undefined,
                    "coordinates": {
                        "startpoint": {
                            "x": undefined,
                            "y": undefined
                        },
                        "endpoint": {
                            "x": undefined,
                            "y": undefined
                        }
                    }
                }
            }
        }];
        var objProperties = {
            type: "measurement",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.MEASUREMENT-OBJECT.LABEL',
            cssClass: "new-measurement-object",
            icon: "cms/icon-measurement.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.MEASUREMENT-OBJECT.DESCRIPTION',
            group: {
                id: 3
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}